import { umsClient } from '@app/helpers/requests/client';

export const fetchUMSUser = async () => {
  const response = await umsClient.get('/me');
  return response.data;
};
